import Balance from '@/utils/balance';
import MaskView from '@/components/common/MaskView.vue';
import Dialog from '@/components/common/Dialog.vue';
import Footer from '@/components/common/Footer';
import RUC from '@/utils/Ruc';
import * as types from '@/store/mutation-types';
import Clipboard from 'clipboard';
import Fiat from '@/utils/fiat';
import Assets from '@/utils/asset';
import { sendWebSocketObj } from '@/utils/websocket';
import Config from '@/utils/Config';
import Utils from '@/utils/Utils';
import { ConstantUtil } from '@/utils/ConstantUtil';

const BigNumber = require('bignumber.js');

BigNumber.config({
    ROUNDING_MODE: BigNumber.ROUND_FLOOR,
});
let assetsInfo = localStorage.getItem('assetsInfo');
assetsInfo = assetsInfo ? JSON.parse(assetsInfo) : {};
if (assetsInfo.constructor == Array) {
    assetsInfo = {};
}
export default {
    name: 'Balance',
    components: {
        MaskView,
        Dialog,
        Footer,
    },
    data() {
        return {
            zindex: 3,

            // -----------Mask-------
            /**
             * @maskStatus 0 hide 1 show
             */
            maskStatus: 0,
            // ------------Mask End-------
            // -----------Dialog-------
            /**
             * @dialog 0 hide 1 show
             * @btnStatus type of dialog
             */
            hide0: false,
            dialog: 0,
            btnStatus: '',
            warningMsg: {},
            balance: [],
            balanceBc: [],
            assets: assetsInfo,
            btnTitle: '',
            asset: '',
            assetId: '',
            allCValue: 0,
            allUValue: 0,
            chainType: 0,
            depositMini: 0,
            withdrawMini: 0,
            available: 0,
            address: '',
            amountOutIDs: [],
            currTarget: {},
            availableBtt: 0,
            // ------------Dialog End-------
            searchAssets: '',
            formItem: {
                channel: 'indacoin',
                address: '',
                amountIn: '',
                amountOut: 0,
                currency: '',
                token: '',
                appid: '1',
            },
            Config,
            computedPrice: false,
            modalSuccess: false,
            userid: '',
            amountIn: [],
            amountOut: [],
            amountOutNames: [],
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        webSocketIsConnected() {
            return this.$store.state.socket.isConnected;
        },
        assetWebScokcetStatus() {
            return this.$store.state.assetWebScokcetStatus;
        },
        signStatus() {
            return this.$store.state.signStatus;
        },
        balances() {
            return this.$store.state.balances;
        },
        currAccountIndex() {
            return this.$store.state.currAccountIndex;
        },
        confirmStatus() {
            return this.$store.state.confirmStatus;
        },
        accountList() {
            return this.$store.state.accountList;
        },
        warningMsgBackup() {
            return {
                deposit: [
                    {
                        normal: this.$t('balance_do_not_deposit_any_non_eth_assets_to_this_address', { asset: this.asset }),
                    },
                    {
                        normal: this.$t('balance_min_deposit_amount'),
                        color: '0.1',
                    },
                ],
                withdraw: [{
                    normal: this.$t('balance_min_withdraw_amount'),
                    color: '0.1',
                },
                {
                    normal: this.$t('balance_be_sure_to_check_the_security'),
                },
                ],
                fiat: [{
                    normal: this.$t('balance_min_deposit_amount'),
                    color: '50',
                    currency: '',
                },
                {
                    a: 'Tutorial',
                    href: 'https://bytetrade.zendesk.com/hc/en-gb/articles/360002313017-Fiat-Deposit-Maximum-Limits',
                    normal: 'The limit of maximum $200 for first transaction for other restrictions please see ',
                },
                {
                    a: 'View restricted areas',
                    href: 'https://bytetrade.zendesk.com/hc/en-gb/articles/360002316378-Fiat-Deposit-Restrict-Areas',
                    normal: 'The legal currency payment channel is not available in certain areas, click to ',
                },
                ],

            };
        },
    },
    watch: {
        currAccountIndex(n, o) {
            const self = this;
            if (n !== o) {
                self.userid = self.$store.state.accountList[n].userid;
                self.occupyBalance();
            }
        },

        accountList(n, o) {
            const self = this;
            if (n !== o) {
                self.accountlist = n;
            }
        },
        balances() {
            this.refreshBalance();
        },
        signStatus() {
            const self = this;
            function fetchAsset() {
                if (self.signStatus > 0 && self.assetWebScokcetStatus == 0 && self.balance.length > 0) {
                    return sendWebSocketObj(self, 'asset', self.balance.map(item => item.id));
                }
                return setTimeout(() => {
                    fetchAsset();
                }, 1000);
            }
            fetchAsset();
        },
    },
    mounted() {
        if (Config.CenterTrade && !this.user.email) {
            return this.$router.push('/Login');
        }
        if (!Config.CenterTrade && !this.$store.getters.currAccount) {
            return this.$router.push('/Register');
        }
        const self = this;
        Fiat.getAmountList({ channel: 'indacoin' }).then((res) => {
            if (res.data.code === 0) {
                self.amountIn = res.data.amountIn;
                self.amountOut = res.data.amountOut;
                self.amountOutIDs = res.data.amountOut.map(item => item.id);
            } else {
                self.$Message.error(self.$t('Error'));
            }
        }).catch((err) => {
            console.log(err, 'err');
        });
        Assets.getAssets().then((res) => {
            console.log({ assets: res });
        });
        return this.occupyBalance();
    },

    methods: {
        createTransaction() {
            const self = this;
            if (this.formItem.currency === '' || this.formItem.token === '' || this.formItem.amountIn === '') {
                return self.$Message.error('Not allow empty');
            }
            if (this.computedPrice === 0) {
                return self.$Message.error('wait for compute!');
            }
            const chainType = this.amountOut.filter(item => item.name == this.formItem.token)[0].chainType;
            this.formItem.address = this.getAddress(chainType);
            this.formItem.userid = this.userid;
            Fiat.createTransaction(this.formItem).then((res) => {
                if (res.data.code === 0) {
                    window.open(res.data.payUrl, '_target');
                    self.modalSuccess = true;
                } else {
                    self.$Message.error(self.$t('Error'));
                }
            }).catch((err) => {
                console.log(err);
            });
            return undefined;
        },
        ok() {
            this.$router.push('/History?type=fiat');
        },
        cancel() {

        },
        changeToken() {
            const self = this;
            self.computedPrice = false;
            if (this.formItem.currency != '' && this.formItem.token != '' && this.formItem.amountIn != '') {
                Fiat.getCoinConvertAmount({
                    channel: 'indacoin',
                    currency: this.formItem.currency,
                    token: this.formItem.token,
                    amountIn: this.formItem.amountIn,
                }).then((res) => {
                    if (res.data.code === 0) {
                        self.formItem.amountOut = res.data.amountOut;
                        self.computedPrice = true;
                    } else {
                        self.$Message.error(self.$t('Error'));
                    }
                });
            }
        },
        refreshBalance() {
            this.occupyBalance();
        },
        toBigNumber(val) {
            return BigNumber(val);
        },
        searchAsset() {
            const self = this;
            let balances = self.balance;
            const va = self.searchAssets;
            const newBalance = [];
            if (va === '') {
                self.balance = self.balanceBc;
                return;
            }
            if (balances.length !== self.balanceBc.length) {
                balances = self.balanceBc;
            }
            balances.forEach((v) => {
                if (v.asset.indexOf(va.toUpperCase()) > -1) {
                    newBalance.push(v);
                }
            });
            self.balance = newBalance;
        },
        hideMaskView() {
            const self = this;
            if ((self.btnStatus === 'transfer' || self.btnStatus === 'withdraw') && self.confirmStatus) {
                this.$store.commit(types.CHANGE_CONFIRMSTATUS, false);
                self.dialog = true;
            } else {
                self.dialog = false;
                self.maskStatus = false;
            }
        },
        hideNoneBalance() {
            const self = this;
            const balance = self.balance;
            const newBalance = [];
            balance.forEach((v) => {
                if (parseFloat(v.available) > 0 || parseFloat(v.freeze) > 0) {
                    newBalance.push(v);
                }
            });
            if (self.hide0) {
                self.balanceBc = balance;
                self.balance = newBalance;
            } else {
                self.balance = self.balanceBc;
            }
        },
        occupyBalance() {
            const self = this;
            let currUser = '';
            if (!Config.CenterTrade) {
                const AccountList = self.$store.state.accountList;
                const currAccountIndex = self.$store.state.currAccountIndex;
                currUser = AccountList[currAccountIndex].userid;
            } else {
                currUser = this.user.bttUserid;
            }
            RUC.checkInviter(currUser, this);

            if (self.signStatus == 0) {
                sendWebSocketObj(self, 'sign', [currUser]);
            }
            const token = Utils.getQueryObject().token;
            const session = Utils.getSession();
            let userToken = '';
            let email = '';
            const tokenInfo = Utils.getToken(token);

            if (session.email) {
                userToken = session.token;
                email = session.email;
            }
            Balance.getBalance(currUser, 'balance', userToken, email).then((res) => {
                self.calculateValue(res.balances);
                self.balance = res.balances;
                self.balanceBc = res.balances;
                if (token && tokenInfo.email) {
                    const item = res.balances.find(asset => asset.id === tokenInfo.asset);
                    self.showDialog('fiat', item.chain_type, item.id, item.pixiu_min_withdraw_amount, item.available, null, item);
                }
            });
            RUC.getDepositAddress(currUser).then((res) => {
                if (res.code === 2 || res.code === 0) {
                    self.assets = res.data;
                    localStorage.setItem('assetsInfo', JSON.stringify(res.data));
                }
            });
        },
        calculateValue(data) {
            const self = this;
            let allCValue = 0;
            let allUValue = 0;
            data.forEach((v) => {
                allUValue += v.price.USD * parseFloat(v.available);
                allCValue += v.price.CNY * parseFloat(v.available);
            });
            self.allCValue = allCValue;
            self.allUValue = allUValue;
        },
        showDialog(eventId, chainType, assetId, wm, avia, index, currency) {
            const self = this;
            self.asset = currency.asset;
            self.assetId = assetId;
            self.$store.commit(types.CHANGE_CONFIRMSTATUS, false);
            if (eventId) {
                self.btnStatus = eventId;
                const warningMsg = self.warningMsgBackup[eventId];
                if (eventId === 'deposit') {
                    self.btnTitle = `Deposit ${currency.asset}`;
                    this.clipboard = new Clipboard('.js-copy-btn');
                    warningMsg[1].color = self.assets.assets[assetId].pixiuDepositMinAmount;
                    if (ConstantUtil.BCHID.has(assetId)) {
                        warningMsg[2] = {
                            normal: this.$t('balance_deposit_address_hint_bch'),
                        };
                    }
                } else if (eventId === 'withdraw') {
                    self.btnTitle = `Withdraw ${currency.asset}`;
                    warningMsg[0].color = self.assets.assets[assetId].pixiuWithdrawMinAmount;
                } else if (eventId === 'fiat') {
                    self.btnTitle = 'Fiat Deposit';
                    warningMsg[0].color = '-';
                    warningMsg[0].currency = currency.asset;
                    Fiat.getCoinConvertAmount({
                        channel: 'indacoin',
                        currency: 'USD',
                        token: currency.asset,
                        amountIn: 50,
                    }).then((res) => {
                        if (res.data.code === 0) {
                            warningMsg[0].color = res.data.amountOut;
                        } else {
                            self.$Message.error(self.$t('Error'));
                        }
                    });
                } else if (eventId === 'transfer') {
                    self.btnTitle = `Transfer ${currency.asset}`;
                }
                self.warningMsg = warningMsg;
                self.chainType = chainType;
                self.getAddress();
                self.available = avia;
                self.dialog = 1;
                self.maskStatus = 1;
                self.currTarget = currency;
                self.availableBtt = parseFloat(self.balance[0].available);
            }
        },
        getAddress(assetId = this.assetId) {
            const assets = this.assets.assets;
            if (assets && assetId && assets[assetId]) {
                this.address = assets[assetId].address;
            } else {
                this.address = '';
            }
            return this.address;
        },
        hideDialog() {
            const self = this;
            self.warningMsg = {};
            self.maskStatus = 0;
            self.dialog = 0;
            setTimeout(() => {
                self.occupyBalance();
            }, 3000);
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/userBalance.js